import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { BrowserModule } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'app-kanban-assignment-bottom-sheet',
	template: `
		<mat-nav-list>
			<a mat-list-item (click)="toggleScrollBooster()">
				<span mat-line>
					<div class="flex justify-center gap">
						{{ (shouldDisableScrollBooster$ | async) === true ? 'גלילת טאץ' : 'גלילה ידנית' }}
					</div>
				</span>
			</a>
		</mat-nav-list>
	`,
	// styleUrls: ['./kanban-assignment.component.scss'],
	standalone: true,
	imports: [MatBottomSheetModule, MatListModule, CommonModule],
})
export class KanbanAssignmentBottomSheetComponent {
	bottomSheetRef = inject(MatBottomSheetRef<KanbanAssignmentBottomSheetComponent>);

	shouldDisableScrollBooster$ = new BehaviorSubject<boolean>(!!JSON.parse(localStorage.getItem('ScrollBoostKanban')));

	toggleScrollBooster() {
		const newValue = !this.shouldDisableScrollBooster$.value;
		localStorage.setItem('ScrollBoostKanban', JSON.stringify(newValue));
		location.reload();
	}
}
